
/*
 * Main 1.0,  Matthew Quinn, GRAND Creative Inc.  Copyright 2012
 *
 *  Dependancies: JQuery >=1.8 and < 2.0
 *
 *  This is the main Javascript class for launching the app/web site.
*/

import MediaQuery from './utils/MediaQuery';
import MenuController from './MenuController';
import Utils from './utils/Utils';

function App(options) {

	// retreive options
	this.options = options || {};
	this.sitePage = this.options.page;
  this.jsPages = ['Entry','Explore','Guidelines','Jury','Submit','VideoEntry','Winners'];


	$('document').ready( $.proxy( this.handleAppReady, this ) );

	this.alertFallback = false;
	if (typeof console === "undefined" || typeof console.log === "undefined") {
		console = {};
		if (this.alertFallback) {
			console.log = function(msg) {
				alert(msg);
			};
		} else {
			console.log = function() {};
		}
	}

}

App.prototype = {

	handleAppReady: function() {

		//init the media query detector
		this.mq = new MediaQuery();
		this.mq.compareWidth = $('#mediaQueryDetector').width();

		$(window).on('mediaQueryChange', $.proxy( this.handleMediaQueryChange, this ) );
		//$(window).scroll( $.proxy( this.handleScroll, this ) );

		this.handlePageOpen(null, this.sitePage);

		//hide address bar on mobile
		//$(window).scrollTop(0);

		//avoid using the :hover pseudo class when touching elements
		if ('ontouchstart' in document) {
			$('body').removeClass('no-touch');
		}

		//INIT THE MENU
		this.menu = new MenuController();

		this.handleMediaQueryChange(null,$(window).width());

		$(window).scroll( $.proxy(this.handleScroll, this) );
		$(window).resize( $.proxy(this.handleScroll, this) );

	},

	handleScroll: function(e) {
		this.adjustHeaderNav();
	},

	handleResize: function(e) {

		this.adjustHeaderNav();

	},

	adjustHeaderNav: function() {
		var barHeight = (parseInt($('nav .navButton').css('top')) * 2) + $('nav .navButton').height();

		if( $(window).scrollTop() > $('.logo').offset().top + barHeight  && !Utils.isTouch() ) {
			var offset = $(window).scrollTop() - ($('header').height() - barHeight);
			$('.touchBar').css('height', barHeight + 'px').fadeIn(200);
			$('nav .toggle span').css('color','#4aa082');
			if( $(window).width() < 1024 ) {
				$('nav .donate').fadeOut();
			}

		} else if( $(window).scrollTop() > $('.logo').offset().top + barHeight ) {
			$('.touchBar').css('height',barHeight + 'px').fadeIn(400);
			$('nav .toggle span').css('color','#4aa082');
			if( $(window).width() < 1024 ) {
				$('nav .donate').fadeOut();
			}
		} else {
			$('header').css('top', '0px');
			$('.touchBar').fadeOut(300);
			$('nav .toggle span').css('color','#fff');
			if( $(window).width() < 1024 ) {
				$('nav .donate').fadeIn();
			}
		}
	},

	handlePageOpen: function(e, page) {

		//launch the current page's controller if its available
    if ( typeof this.sitePage !== 'undefined' && this.sitePage !== '' && this.jsPages.indexOf(this.sitePage) > -1 ) {
      const PageController = require(`./${this.sitePage}Controller`);
      this.pageController = new PageController(this.options);
    } else {
      console.log('PAGE CONTROLLER NOT LOADED');
    }

	},

	handlePageClose: function(e, page) {

		//destroy the page conroller
			//this.pageController.destroy();
			//delete this.pageController;

	},

	handleMediaQueryChange: function(e,width) {

		console.log("WIDTH: " + width);

		//unset any break point related navigation
		this.menu.unsetNav();


		/* Do -Site Wide- specific actions when the browser is resized to a particular break point */

		if( width < 460 ) {	//PHONES VERT

		}

		if( width >= 460 && width <= 640 ) {	//PHONES HORZ

		}

		if( width < 640 ) { ///PHONES & TINY TABS - BOTH ORIENTATIONS
			this.menu.setupNav('slideout');
		}

		if( width > 640 && width <= 1024 ) { // TABS

		}

		if( width >= 640 ) { // TABS & DESKTOP
			this.menu.setupNav('flyout');
		}

		if( width > 640 && width <= 768 ) {	//TABS VERT

		}

		if( width > 768 && width <= 1024 ) {	//TABS HORZ

		}

		if( width <= 1024 ) { //PHONES & TABS

		}

		if( width > 1024 ) { //DESKTOPS

		}

	}

};

module.exports = App;



// WEBPACK FOOTER //
// ./js/src/App.js